import en from './en';
import ru from './ru';
import kk from './kk';
import zh from './zh';

export const translations = { en, ru, kk, zh };

export const languages = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'ru', label: 'RU', name: 'Русский' },
  { code: 'kk', label: 'KZ', name: 'Қазақша' },
  { code: 'zh', label: '中文', name: '中文' }
];
